import { apiRequest, withToken } from './http-client';

export const userCreate = async (token, data) => {
    return apiRequest({
        method: 'post',
        url: '/user/',
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const userInviteCreate = async (token, data) => {
    return apiRequest({
        method: 'post',
        url: '/user/invite',
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const resendUserInvitation = async (token, userId) => {
    return apiRequest({
        method: 'post',
        url: `/user/${userId}/resend-invitation`,
        headers: withToken(token),
    }, 'No se pudo reenviar la invitación');
};

export const getUserList = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/user/',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const getUserById = async (token, userId) => {
    return apiRequest({
        method: 'get',
        url: `/user/${userId}`,
        headers: withToken(token),
        params: {
            includeDeleted: true,
        },
    }, 'No se pudo validar la sesión');
};

export const searchUserList = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/user/search',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const updateUserItem = async (token, userId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/user/${userId}`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const updateMyAvailability = async (token, available) => {
    return apiRequest({
        method: 'patch',
        url: '/user/me/availability',
        headers: withToken(token),
        data: {
            available,
        },
    }, 'No se pudo actualizar la disponibilidad');
};

export const getMyProfile = async (token, userId) => {
    return apiRequest({
        method: 'get',
        url: `/user/${userId}`,
        headers: withToken(token),
        params: {
            includeDeleted: true,
        },
    }, 'No se pudo obtener el perfil del usuario');
};

export const updateMyProfile = async (token, data) => {
    return apiRequest({
        method: 'patch',
        url: '/user/me/profile',
        headers: withToken(token),
        data,
    }, 'No se pudo actualizar el perfil');
};

export const updateMyPassword = async (token, data) => {
    return apiRequest({
        method: 'patch',
        url: '/user/me/password',
        headers: withToken(token),
        data,
    }, 'No se pudo actualizar la contraseña');
};

export const deleteUserItem = async (token, userId) => {
    return apiRequest({
        method: 'delete',
        url: `/user/${userId}`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};
